// Module
var code = "<div id=\"applePayButtonContainer\"></div> ";
// Exports
module.exports = code;